import { render } from "./VersionsIndex.vue?vue&type=template&id=68cc3032"
import script from "./VersionsIndex.vue?vue&type=script&lang=js"
export * from "./VersionsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__